import React, {useState} from 'react'
import { NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import icon from '../assets/iconlogo.svg'
import '../Component/css/Header.css'

function Header() { 
    //update toggle state
    const [click, setClick] = useState(false); 

    function toogleModeMenu() {
        if (click === false) {
            setClick (true)
        } else {
            setClick (false)
        }
    }

    return (
        <div className="navbar">
            <button className='nav-toggler' onClick={toogleModeMenu}>
                <span></span>
            </button>        
            <div className={click ? 'main' : 'main-empty'} >
                <header className='header'>
                    <div className="container">
                        <div className="header-row">
                            <nav className="nav" >
                                <div className='nav-inner'>
                                    <ul>
                                        
                                    <motion.img src={icon} alt="profile" whileHover={{ scale:1.2}} transition={{type:'tween'}}  className='nav-image'/>

                                    {/* <NavLink to='/' onClick={() => setClick(false)} style={{ textDecoration: 'none' }} ><motion.li whileHover={{originY:2, scale:1.1}} transition={{type:'tween'}} className='nav-item'>home</motion.li></NavLink> */}

                                    <NavLink to='/' onClick={() => setClick(false)}style={{ textDecoration: 'none' }} ><motion.li whileHover={{originY:2, scale:1.1}}  transition={{type:'tween'}} className='nav-item'>portfolio</motion.li></NavLink>

                                    <NavLink to='/About' onClick={() => setClick(false)} style={{ textDecoration: 'none' }} ><motion.li whileHover={{originY:2, scale:1.1 }} transition={{type:'tween'}} className='nav-item'>about</motion.li></NavLink>

                                    {/* <NavLink to='/Resume' onClick={() => setClick(false)}style={{ textDecoration: 'none' }} ><motion.li whileHover={{originY:2, scale:1.1}}  transition={{type:'tween'}} className='nav-item'>Résumé</motion.li></NavLink> */}

                                    <NavLink to='/Contact' onClick={() => setClick(false)} style={{ textDecoration: 'none' }} ><motion.li whileHover={{originY:2, scale:1.1}} transition={{type:'tween'}} className='nav-item'>contact</motion.li></NavLink>                                

                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </header>
            </div>
        </div> 
    )
}

export default Header
 